export default {
  'menu.workbench': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.customer-intelligence': '顧客インテリジェンス',
  'menu.customer-intelligence.customer-list': '顧客一覧',
  'menu.customer-intelligence.customer-detail': '顧客詳細',
  'menu.settings': 'システム設定',
  'menu.solution-advancement': '提案推進センター',
  'menu.solution-advancement.detail': '推進詳細',
  'menu.settings.code-rules': 'コードルール',
  'menu.settings.dict': '辞書管理',
  'menu.settings.tag-pool': 'タグ管理',
  'menu.zy-consultant-operations': '問題バンク',
  'menu.zy-consultant-operations.question-bank': '問題一覧',
  'menu.zy-consultant-operations.question-bank.detail': '質問詳細',
  'menu.zy-consultant-operations.question-packs': '質問パック',
  'menu.zy-consultant-operations.question-packs.detail': 'パック詳細',
  'menu.zy-consultant-operations.diagnosis-sessions': '診断セッション',
  'menu.zy-consultant-operations.diagnosis-sessions.detail':
    '診断セッション詳細',
  'menu.zy-consultant-operations.diagnosis-sessions.run': '診断実行',
  'menu.zy-consultant-operations.diagnosis-sessions.result': '診断結果',
  'menu.methodology-center': '方法論ナレッジセンター',
  'menu.methodology-center.industry-cases': '業界事例庫',
  'menu.methodology-center.common-pain-points': 'よくある課題庫',
  'menu.methodology-center.solution-playbooks': 'ソリューション庫',
  'menu.methodology-center.pilot-scenes': 'パイロットシーン庫',
  'menu.methodology-center.talk-tracks': 'トークトラック庫',
  'menu.methodology-center.failure-reasons': '失敗要因庫',
  'menu.methodology-center.success-playbooks': '成功プレイブック庫',
  'menu.methodology-center.industry-templates': '業界テンプレート庫',
  'menu.methodology-center.analysis-logics': '分析ロジック庫',
  'menu.methodology-center.library-detail': 'ライブラリ詳細',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
